@if(iosOrAndroid()) {
<table [formGroup]="formGroup">
  <thead>
    <tr>
      <th>Item</th>
    </tr>
  </thead>
  <tbody formArrayName="items">
    @for (
    formRow of formGroup.controls.items.controls;
    let index = $index;
    track index
    ) {
    <tr mobile-assign-items-table-row [index]="index" [formRow]="formRow" [productItems]="alternativeProductItems[
      formRow.value.bookingItem.id
    ]" [itemControl]="formGroup.controls.items.at(index).get('item')">
    </tr>
    }
  </tbody>
</table>
} @else {
<table [formGroup]="formGroup">
  <thead>
    <tr>
      <th>Qty</th>
      <th>Name</th>
      <th>Item</th>
      <th>On hire date</th>
      <th>Off hire date</th>
      <th>Charge</th>
    </tr>
  </thead>
  <tbody formArrayName="items">
    @for (
    formRow of formGroup.controls.items.controls;
    let index = $index;
    track index
    ) {
    <tr assign-items-table-row [index]="index" [formRow]="formRow" [productItems]="alternativeProductItems[
        formRow.value.bookingItem.id
      ]" [itemControl]="formGroup.controls.items.at(index).get('item')">
    </tr>
    }
  </tbody>
</table>
}